import React from 'react'
import style from '../startedsoon/startsoon.module.css'

function Agstya() {
  return (
    <div className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/05b30dd5b1154688b17c563e9366c6b9.png?q=100&w=512' alt='_Sumit_img'/>
        <div>
        <p>HINDI    SCIENCE</p>
        <h4>Super 30 : Practice Course on Biology for NDA I - 2022</h4> 
        <p>Lesson 16 • Mar 2, 2022 6:00 AM</p> 
        <p>Shweta Batra</p>  
        </div>
    </div>        
  )
}
export default Agstya;